module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', [_c('a', {
    attrs: {
      "id": "pg25lev2"
    }
  }), _c('img', {
    attrs: {
      "alt": "Pan con tomate",
      "src": "images/f0025-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "recipe_hdnote"
  }, [_vm._v("This is my take on the classic tomato on bread that is ubiquitous in Spanish wine and tapas bars. This is possibly one of the simplest tapas you’ll find, but I have jazzed mine up with a herby and garlicky butter.")]), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('img', {
    staticClass: "vertical",
    attrs: {
      "alt": "a couple of small plates of food and a bunch of friends is my favorite way to relax,",
      "src": "images/f0026-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_vm._v("Serves 4")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_vm._v("Cooking time: 5 minutes")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_vm._v("Preparation time: 10 minutes")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common2.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_vm._v("4 large slices sourdough bread")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_vm._v("10"), _c('sup', [_vm._v("1")]), _vm._v("/"), _c('sub', [_vm._v("2")]), _vm._v(" oz heirloom tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_vm._v("1"), _c('sup', [_vm._v("1")]), _vm._v("/"), _c('sub', [_vm._v("2")]), _vm._v(" oz fresh basil, or whatever herbs you like")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_vm._v("2 cloves of garlic, peeled")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_vm._v("6 tbsp salted butter")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_vm._v("sea salt and freshly ground pepper")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_vm._v("pinch of sweet smoked paprika (optional)")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_vm._v("Grill or toast the bread on both sides. Thinly slice the tomatoes.")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_vm._v("In a small blender or by hand, very finely chop the basil and garlic and mix together. Melt the butter in a small saucepan and add the herbs and garlic to it. Add a pinch of salt and pepper and remove from the heat before the butter browns.")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_vm._v("Pile the tomatoes high onto the toasted bread and drizzle with the hot garlic-herb butter. Finish with a sprinkle of sweet smoked paprika, if desired, before serving.")]), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('img', {
    staticClass: "vertical",
    attrs: {
      "alt": "image",
      "src": "images/f0027-01.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4dabccf2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/13-chapter07.vue
// module id = 93
// module chunks = 0